import {Address, LocalAddress, RestaurantFromGet, RestaurantFromSearch} from '~/shared/store/models';
import {isRestaurantFromGet} from '~/shared/utils/restaurant';
import {getActiveDeliveryRules} from '~/shared/utils/restaurants/getActiveDeliveryRules';
import {createLogger} from '~/shared/logging';

const logger = createLogger('isAsapAndFutureRestaurant');

const isAsapAndFutureRestaurant = (
  restaurant: RestaurantFromGet | RestaurantFromSearch,
  address?: Address | LocalAddress | undefined,
) => {
  if (isRestaurantFromGet(restaurant)) {
    if (!address) {
      logger.warn('No address was passed. When using RestaurantFromGet you should also pass the current address');
      return false;
    }

    const activeDeliveryRules = getActiveDeliveryRules(restaurant, address);

    return !!activeDeliveryRules?.Asap && !!activeDeliveryRules?.Future && !activeDeliveryRules.Pool;
  }

  return !restaurant.hasActivePoolRule && restaurant.isOpenNow && restaurant.futureOrdersAvailable;
};

export default isAsapAndFutureRestaurant;
